(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/section-odds-live/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/components/banner_layouts/section-odds-live/assets/javascripts/helpers.js');


'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const kambiOffering = svs.isServer ? trinidad.components.require('oddset', 'kambi-offering').offering : svs.components.oddset.kambiOffering;
const kambiConstants = svs.isServer ? trinidad.components.require('oddset', 'kambi-offering').constants : svs.components.oddset.kambiOffering.common.constants;
const deepLink = svs.isServer ? trinidad.components.require('oddset', 'kambi-offering').deepLink : svs.components.oddset.kambiOffering;
const normalize = svs.isServer ? trinidad.components.require('oddset', 'kambi-offering').normalize : svs.components.oddset.kambiOffering.common.normalize;
const oddsetAccessibilityHelpers = svs.isServer ? trinidad.components.require('oddset', 'kambi-offering').accessibilityHelpers : svs.components.oddset.kambiOffering;
const sportProducts = svs.isServer ? trinidad.components.require('lb-utils', 'sport-products').api : svs.components.lbUtils.sportProducts;
const {
  getFormattedDate
} = svs.isServer ? trinidad.components.require('lb-utils', 'helper-formatdate').api : svs.components.lbUtils.helpers.formatDate;
const {
  getOddsetBetslipQueryString
} = svs.isServer ? trinidad.components.require('oddset', 'common').utils : svs.components.oddset.common.utils;
const getCallToAction = svs.isServer ? trinidad.components.require('banner_common', 'banner-helpers').getCallToAction : svs.banner_common.banner_helpers.getCallToAction;
const BET_OFFER_CACHE_KEY = 'bet_offer_cache';
const {
  PeriodId
} = kambiConstants;
const EventState = Object.freeze({
  NOT_STARTED: 'NOT_STARTED',
  STARTED: 'STARTED',
  FINISHED: 'FINISHED',
  UNKNOWN: 'UNKNOWN'
});
const BetOfferType = Object.freeze({
  HANDICAP: 1,
  ONE_X_TWO: 2,
  RESULT: 3,
  OUTRIGHT: 4,
  OVER_UNDER: 6,
  ASIAN_HANDICAP: 7,
  HALFTIME_FULLTIME: 8,
  SIDE_BET: 9,
  ODD_EVEN: 10,
  THREE_WAY_HCP: 11,
  DOUBLE_CHANCE: 12,
  HEAD_TO_HEAD: 13,
  SCORER: 17,
  YES_NO: 18,
  MULTIPOSITION: 19,
  ASIAN_OVER_UNDER: 21,
  POSITION: 117,
  WINNING_MARGIN: 124,
  PLAYER_OCCURRENCE_NUMBER: 125,
  PLAYER_LAST_OCCURRENCE: 126,
  PLAYER_OCCURRENCE_LINE: 127,
  OCCURRENCE_METHOD: 128 
});
const BetOfferTag = Object.freeze({
  MAIN: 'MAIN'
});
class Queue {
  constructor() {
    _defineProperty(this, "callbacks", []);
    this.next = this.next.bind(this);
    this.add = this.add.bind(this);
    this.run = this.run.bind(this);
  }
  next() {
    const cb = this.callbacks.shift();
    if (cb) {
      requestAnimationFrame(() => cb(this.next));
    }
  }
  add(callback) {
    this.callbacks.push(callback);
    return this;
  }
  run() {
    this.next();
  }
}
const logger = getLogger('banner_layouts:section-odds-live');
let betOfferIntervalId;
const getCacheHandler = isAdmin => ({
  clear: () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(BET_OFFER_CACHE_KEY);
    }
  },
  set: data => {
    if (typeof localStorage !== 'undefined' && isAdmin) {
      localStorage.setItem(BET_OFFER_CACHE_KEY, LZString.compressToUTF16(JSON.stringify(data)));
    }
  },
  get: () => {
    if (typeof localStorage !== 'undefined' && isAdmin) {
      const lsData = localStorage.getItem(BET_OFFER_CACHE_KEY);
      try {
        return JSON.parse(LZString.decompressFromUTF16(lsData)) || {};
      } catch (err) {
        logger.debug('Could not parse cache string, removing current and returning empty');
        localStorage.removeItem(BET_OFFER_CACHE_KEY);
        return {};
      }
    }
    return {};
  }
});
const getFormattedEyebrow = event => {
  const startDate = new Date(event === null || event === void 0 ? void 0 : event.start);
  const isValid = !isNaN(startDate.getTime());
  let timeString = '';
  if (isValid) {
    const time = startDate.toLocaleString('sv-se', {
      hour: '2-digit',
      minute: '2-digit'
    });
    const formattedDate = getFormattedDate(startDate, true, true, true);
    timeString = "".concat(formattedDate, " kl ").concat(time);
  } else {
    timeString = '';
  }
  switch (event.state) {
    case EventState.STARTED:
      return {
        group: event.group,
        time: ''
      };
    default:
      return {
        group: event.group,
        time: timeString
      };
  }
};
const resolveCallToActions = (normalizedOutcomes, eventUrl) => {
  let betActions;
  let eventCta;
  if (normalizedOutcomes !== null && normalizedOutcomes !== void 0 && normalizedOutcomes.length) {
    betActions = normalizedOutcomes.map(outcome => ({
      ariaLabel: oddsetAccessibilityHelpers.getOutcomeAriaLabel(outcome),
      id: outcome.id,
      odds: outcome.odds,
      linkTitle: outcome === null || outcome === void 0 ? void 0 : outcome.label,
      linkOdds: outcome.odds,
      linkDescription: 'Bet-knapp',
      linkUrl: "".concat(eventUrl).concat(getOddsetBetslipQueryString(outcome.id))
    }));
    eventCta = undefined;
  } else {
    betActions = [];
    eventCta = {
      linkTitle: 'Gå till spelet',
      linkDescription: 'Gå till spelet-knapp',
      linkUrl: eventUrl
    };
  }
  return {
    eventCta,
    betActions
  };
};
const actionViewConfig = {
  inverted: false,
  transparent: false,
  block: false
};
const normalizeCta = function (betActions, actionDescriptionId) {
  let modelActions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!betActions) {
    return [];
  }
  return modelActions.map(action => {
    switch (action.actionType) {
      case 'bet-actions':
        return getCallToAction(action, _objectSpread(_objectSpread({}, actionViewConfig), {}, {
          betActions: betActions.map(action => _objectSpread(_objectSpread({}, action), {}, {
            describedBy: actionDescriptionId
          }))
        }));
      default:
        return getCallToAction(action, actionViewConfig);
    }
  });
};
const resolveBetOffer = (eventId, betOfferTypes, isAdmin) => new Promise(resolve => {
  const eventIdIsInteger = Number.isInteger(parseInt(eventId, 10));
  const cacheHandler = getCacheHandler(isAdmin);
  const cache = cacheHandler.get();
  let {
    event,
    eyebrow,
    betActions,
    eventCta,
    outcomes,
    eventUrl
  } = cache;
  clearTimeout(betOfferIntervalId);
  const getAndCompileBetOffer = async () => {
    try {
      const betOfferResult = await kambiOffering.getBetOffers(Number(eventId), betOfferTypes, {
        includeParticipants: true,
        onlyMain: true
      });
      if (betOfferResult && !betOfferResult.error) {
        var _betOfferResult$event, _betOffers$filter;
        const betEvent = (betOfferResult === null || betOfferResult === void 0 || (_betOfferResult$event = betOfferResult.events) === null || _betOfferResult$event === void 0 ? void 0 : _betOfferResult$event[0]) || {};
        const betOffers = (betOfferResult === null || betOfferResult === void 0 ? void 0 : betOfferResult.betOffers) || [];
        const selectedBetOffer = ((_betOffers$filter = betOffers.filter(item => item.tags.includes(BetOfferTag.MAIN))) === null || _betOffers$filter === void 0 ? void 0 : _betOffers$filter[0]) || betOffers[0];
        eventUrl = deepLink.getUrlForBetOfferResponse(selectedBetOffer, betOfferResult);
        const normalizedOutcomes = normalize.normalizeOutcomes(selectedBetOffer.outcomes, BetOfferType);
        const callToAction = resolveCallToActions(normalizedOutcomes, eventUrl);
        eventCta = callToAction.eventCta;
        betActions = callToAction.betActions;
        outcomes = selectedBetOffer.outcomes;
        event = betEvent;
        eyebrow = getFormattedEyebrow(betEvent);
      }
    } catch (err) {
      logger.info('resolveBetOffer error:', eventId, betOfferTypes, err);
    }
    cacheHandler.set({
      event,
      eventUrl,
      eyebrow,
      betActions,
      eventCta,
      id: eventId,
      time: Date.now(),
      outcomes
    });
    resolve({
      event,
      eyebrow,
      betActions,
      eventCta,
      eventUrl,
      outcomes
    });
  };
  const resolveWithCache = () => {
    cacheHandler.set(_objectSpread(_objectSpread({}, cache), {}, {
      id: eventId,
      time: Date.now()
    }));
    resolve({
      event,
      eyebrow,
      betActions,
      eventCta,
      eventUrl,
      outcomes
    });
  };
  if (eventIdIsInteger && betOfferTypes) {
    if (isAdmin) {
      if (eventId !== cache.id) {
        betOfferIntervalId = setTimeout(getAndCompileBetOffer, 200);
      } else {
        resolveWithCache();
      }
    } else {
      getAndCompileBetOffer();
    }
  } else {
    resolveWithCache();
  }
});
const resolveLiveData = (eventId, isAdmin) => new Promise(resolve => {
  const getAndCompileLiveData = async () => {
    try {
      var _liveDataResult$liveD;

      const liveDataResult = await kambiOffering.getLiveData(Number(eventId));
      if (liveDataResult.error) {
        throw new Error('Live data error');
      }
      if ((liveDataResult === null || liveDataResult === void 0 || (_liveDataResult$liveD = liveDataResult.liveData) === null || _liveDataResult$liveD === void 0 ? void 0 : _liveDataResult$liveD.length) > 0) {
        const liveData = liveDataResult.liveData.find(value => value.eventId === Number(eventId));
        if (!liveData) {
          resolve({});
        } else {
          resolve(liveData);
        }
      } else {
        resolve({});
      }
    } catch (err) {
      logger.info('resolveBetOffer error:', eventId, err);
      resolve({});
    }
  };
  if (!isAdmin) {
    getAndCompileLiveData();
  } else {
    resolve({});
  }
});
const updateBetOfferPreMatch = async (eventId, betOfferTypes) => {
  const betOfferResult = await kambiOffering.getBetOffers(Number(eventId), betOfferTypes, {
    includeParticipants: true,
    onlyMain: true
  });
  let outcomes = [];
  let event = {};
  let matchClock;
  let score;
  if (betOfferResult && !betOfferResult.error) {
    var _betOfferResult$event2, _betOffers$filter2, _event;
    event = (betOfferResult === null || betOfferResult === void 0 || (_betOfferResult$event2 = betOfferResult.events) === null || _betOfferResult$event2 === void 0 ? void 0 : _betOfferResult$event2[0]) || {};
    const betOffers = (betOfferResult === null || betOfferResult === void 0 ? void 0 : betOfferResult.betOffers) || [];
    const selectedBetOffer = (_betOffers$filter2 = betOffers.filter(item => item.tags.includes(BetOfferTag.MAIN))) === null || _betOffers$filter2 === void 0 ? void 0 : _betOffers$filter2[0];
    outcomes = selectedBetOffer.outcomes;
    if (((_event = event) === null || _event === void 0 ? void 0 : _event.state) === EventState.STARTED) {
      const liveData = await resolveLiveData(eventId);
      score = liveData === null || liveData === void 0 ? void 0 : liveData.score;
      matchClock = liveData === null || liveData === void 0 ? void 0 : liveData.matchClock;
    }
  }
  return {
    outcomes,
    event,
    matchClock,
    score
  };
};
const resolveCube = cube => {
  const productId = cube !== null ? Number(cube) : '';
  if (!productId) {
    return {
      productId: '',
      productName: ''
    };
  }
  return {
    productId,
    productName: productId === 11111 ? 'generic' : sportProducts.getClassName(productId)
  };
};
const twoDigitTimeNumber = num => num < 10 ? "0".concat(num) : num;

const oscillateAnimation = el => {
  el.getAnimations().forEach(anim => anim.cancel());
  const inner = el.offsetWidth;
  const outer = el.parentElement.offsetWidth;
  if (inner > outer) {
    const percent = (inner - outer) / inner * 100;
    return el.animate({
      transform: "translateX(-".concat(percent, "%)")
    }, {
      easing: 'cubic-bezier(0.45, 0, 0.55, 1)',
      duration: Math.max(2000, Math.round(percent * 75)),
      direction: 'alternate',
      iterations: Infinity
    });
  }
};

const slowPoll = function (fn) {
  let interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
  let timeout;
  const poll = () => {
    fn();
    timeout = setTimeout(poll, interval);
  };
  timeout = setTimeout(poll, interval);
  return () => clearTimeout(timeout);
};

const getMatchMinuteFromMatchClock = matchClock => {
  const currentMinute = (matchClock === null || matchClock === void 0 ? void 0 : matchClock.minute) + 1;
  let matchClockString = "".concat(currentMinute, "'");
  switch (matchClock === null || matchClock === void 0 ? void 0 : matchClock.periodId) {
    case PeriodId.FIRST_HALF:
      if (currentMinute > 45) {
        matchClockString = "45'+";
      }
      break;
    case PeriodId.SECOND_HALF:
      if (currentMinute > 90) {
        matchClockString = "90'+";
      }
      break;
    case PeriodId.ET_FIRST_HALF:
      if (currentMinute > 105) {
        matchClockString = "105'+";
      }
      break;
    case PeriodId.ET_SECOND_HALF:
      if (currentMinute > 120) {
        matchClockString = "120'+";
      }
      break;
    case PeriodId.PS:
      matchClockString = 'STR';
      break;
    default:
      break;
  }
  return matchClockString;
};
if (svs.isServer) {
  module.exports = {
    BetOfferType,
    BET_OFFER_CACHE_KEY,
    EventState,
    getCacheHandler,
    getFormattedEyebrow,
    oscillateAnimation,
    resolveBetOffer,
    resolveCube,
    resolveLiveData,
    slowPoll,
    twoDigitTimeNumber,
    updateBetOfferPreMatch,
    Queue,
    resolveCallToActions,
    normalizeCta,
    getMatchMinuteFromMatchClock
  };
} else {
  setGlobal('svs.banner_layouts.section_odds_live.helpers', {
    BetOfferType,
    BET_OFFER_CACHE_KEY,
    EventState,
    getCacheHandler,
    getFormattedEyebrow,
    oscillateAnimation,
    resolveBetOffer,
    resolveCube,
    resolveLiveData,
    slowPoll,
    twoDigitTimeNumber,
    updateBetOfferPreMatch,
    Queue,
    resolveCallToActions,
    normalizeCta,
    getMatchMinuteFromMatchClock
  });
}

 })(window);